<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="saleFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                saleFileForm: () => import('../forms/SaleFileForm'),
                headers: [
                    { text: 'Sale', value: 'saleId', table: 'sales', form: () => import('../forms/SaleForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: 'File Type', value: 'fileType', format: this.formatEnum },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    sales: [],
                    items: []
                },
                sorting: [
                    { column: "saleId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'saleFiles',
                editPageName: 'saleFile',
                apiMethod: 'SaleFiles',
                claimName: 'SaleFiles',
                formTitle: 'Sale File',
                excelTitle: 'Sale Files',
                hasEditPage: false,
            }
        },
    };
</script>
